<template>
    <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive">
            <el-table border stripe :data="data" class="el-table-css" style="width: 100%">
                <!-- Quota Number & Status -->
                <el-table-column label="Təklif nömrəsi" width="280">
                    <template #default="scope">
                        <div class="d-flex align-items-center justify-content-between gap-2">
                            <a class="doc-number-link" @click="GoToQuota(scope.row.quotaId)">
                                <i class="bi bi-file-earmark-diff me-1"></i>{{ scope.row.quotaFullNumber }}
                            </a>
                            <span class="status-badge-pill" :class="getStatusBadgeClass(scope.row.statusId)">
                                {{ scope.row.quotaStatusName }}
                            </span>
                        </div>
                    </template>
                </el-table-column>

                <!-- Date -->
                <el-table-column prop="quotaDateStr" label="Tarix" width="115" align="center">
                    <template #default="scope">
                        <span class="task-time-chip font-monospace">{{ scope.row.quotaDateStr }}</span>
                    </template>
                </el-table-column>

                <!-- Insured Company -->
                <el-table-column prop="insured.name" label="Sığortalı (Şirkət)" min-width="180">
                    <template #default="scope">
                        <span class="fw-bold text-dark-emphasis">
                            <i class="bi bi-building me-1 text-muted"></i>{{ scope.row.insured?.name }}
                        </span>
                    </template>
                </el-table-column>

                <!-- Insured Person -->
                <el-table-column prop="insuredPerson.name" label="Sığorta olunan" min-width="170">
                    <template #default="scope">
                        <span>
                            <i class="bi bi-person me-1 text-muted"></i>{{ scope.row.insuredPerson?.name }}
                        </span>
                    </template>
                </el-table-column>

                <!-- Pay Type -->
                <el-table-column prop="payType" label="Ödənilmə qaydası" width="150" align="center">
                    <template #default="scope">
                        <span class="meta-chip meta-chip--blue">{{ scope.row.payType }}</span>
                    </template>
                </el-table-column>

                <!-- Currency -->
                <el-table-column prop="currency" label="Valyuta" width="95" align="center">
                    <template #default="scope">
                        <span class="meta-chip meta-chip--gray">{{ scope.row.currency }}</span>
                    </template>
                </el-table-column>

                <!-- Period -->
                <el-table-column prop="period" label="Müddət" width="105" align="center">
                    <template #default="scope">
                        <span class="meta-chip meta-chip--green">{{ scope.row.period }} ay</span>
                    </template>
                </el-table-column>

                <!-- Info Popover (widened to 54px to prevent ellipsis dots) -->
                <el-table-column width="54" align="center">
                    <template #default="scope">
                        <el-popover placement="left" :width="240" trigger="hover">
                            <template #reference>
                                <el-button type="default" style="padding: 0 !important;" :icon="InfoFilled" class="edit-btn" text />
                            </template>
                            <template #default>
                                <div class="p-1" style="font-size: 0.8rem; line-height: 1.5;">
                                    <div class="d-flex justify-content-between mb-1">
                                        <span class="text-muted">Daxil olunub:</span>
                                        <span class="fw-bold">{{ scope.row.created || '—' }}</span>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <span class="text-muted">Düzəliş olunub:</span>
                                        <span class="fw-bold">{{ scope.row.updated || '—' }}</span>
                                    </div>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { InfoFilled } from "@element-plus/icons-vue";

export default {
    props: {
        data: Array,
        showFilter: Boolean
    },
    data() {
        return {
            InfoFilled
        };
    },
    methods: {
        GoToQuota(value) {
            window.open(window.location.origin + '/documents/quota/' + value, "_blank");
        },
        getStatusBadgeClass(statusId) {
            if (statusId === 0 || statusId === "0") return "badge--approved";
            if (statusId === 2 || statusId === 4 || statusId === "2") return "badge--in-progress";
            return "badge--rejected";
        }
    }
};
</script>

<style scoped lang="scss">
.task-time-chip {
    font-size: 0.8rem;
    font-weight: 650;
    padding: 2px 6px;
    border-radius: 4px;
    background: var(--app-surface-soft, #f8fafc);
    border: 1px solid var(--app-border, #e2e8f0);
}

.status-badge-pill {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.72rem;
    font-weight: 700;
    white-space: nowrap;

    &.badge--approved {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border: 1px solid rgba(16, 185, 129, 0.35);
    }
    &.badge--in-progress {
        background: rgba(59, 130, 246, 0.12);
        color: #2563eb;
        border: 1px solid rgba(59, 130, 246, 0.35);
    }
    &.badge--rejected {
        background: rgba(239, 68, 68, 0.12);
        color: #dc2626;
        border: 1px solid rgba(239, 68, 68, 0.35);
    }
}

.meta-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.74rem;
    font-weight: 650;

    &--blue {
        background: rgba(11, 79, 156, 0.1);
        color: var(--bs-info, #0b4f9c);
    }
    &--green {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
    }
    &--gray {
        background: rgba(100, 116, 139, 0.12);
        color: #475569;
    }
}

[data-theme="dark"] {
    .task-time-chip {
        background: #141b22;
        border-color: #283544;
        color: #e2e8f0;
    }

    .meta-chip--gray {
        background: rgba(255, 255, 255, 0.1);
        color: #cbd5e1;
    }

    .status-badge-pill {
        &.badge--approved {
            background: rgba(16, 185, 129, 0.2);
            color: #34d399;
            border-color: rgba(52, 211, 153, 0.35);
        }
        &.badge--in-progress {
            background: rgba(59, 130, 246, 0.2);
            color: #93c5fd;
            border-color: rgba(96, 165, 250, 0.35);
        }
        &.badge--rejected {
            background: rgba(239, 68, 68, 0.2);
            color: #fca5a5;
            border-color: rgba(248, 113, 113, 0.35);
        }
    }
}
</style>